import { Component, Input } from '@angular/core';
import { Company } from 'src/app/models/company';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-company]',
  template: `
    <td class="text-start align-middle"><a routerLink="{{company?.pk}}" >{{company?.name}}</a></td>
    <td class="text-start align-middle">{{company?.description}}</td>
    
    <td class="text-center align-middle">{{company?.phone}}</td>
    <td class="text-center align-middle">{{company?.email}}</td>

    <td class="text-center align-middle">{{company?.website}}</td>
    <td class="text-center align-middle">{{company?.active}}</td>

    
  `,
  styles: ``
})
export class TrCompanyComponent {
  @Input() company: Company | null = null;

  constructor(
    public icons: IconsService,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
  }

}
